import { ISSUE_PRIORITY } from '@/_legacy/constants';
import { v4 as uuidv4 } from 'uuid';

export default {
  actionIssue: ({
    id = null,
    title = '',
    description = '',
    suggestedCorrectiveAction = '',
    priority = ISSUE_PRIORITY.MEDIUM,
    assignees = null,
    deadline = null,
    entityItem = null,
    photos = null,
    executedAt = null,
    approvalsEnabled = false,
    approvalsEntitySpecificAssignments = false,
    approvers = null,
  } = {}) => ({
    uuid: uuidv4(),
    type: 'action',
    action: 'issue',
    visible_for_conductor: true,
    executed_at: executedAt,
    approvals_enabled: approvalsEnabled,
    approvals_entity_specific_assignments: approvalsEntitySpecificAssignments,
    params: {
      id,
      title,
      description,
      suggested_corrective_action: suggestedCorrectiveAction,
      deadline,
      priority,
      entity_item: entityItem,
      photos,
      assignees: {
        approvers,
        users: assignees,
        groups: null,
        roles: null,
        entity_items: null,
        administrators: false,
      },
    },
  }),
};
